import TextField from "@mui/material/TextField";
import React from "react";
import { useState } from "react";
import { SoecoButton } from "../../components/SoecoButton";
import { post } from "../../services/restClient";
import styled from "styled-components";
import { setEndpoint, Endpoint } from "../../services/endpoints";
import { useSnackBar } from "../../context/SnackbarContext";
import { useNavigate } from "react-router-dom";
import YLLWLOGO from "../../assets/Yllw_Inventory.svg";
import { Typography } from "@mui/material";

export const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const navigate = useNavigate();
    const snackBar = useSnackBar();

    const handleResetPassword = (event: React.FormEvent) => {
        event.preventDefault();

        type RequestBody = {
            email: string;
        };
        type ResponseBody = RequestBody & {
            message: string;
        };

        post<RequestBody, ResponseBody>(
            setEndpoint(Endpoint.resetPassword),
            {
                email,
            },
            { requireAuth: false },
        )
            .then(() => {
                snackBar.showSnackBar(`Email sent to ${email}`, "success");
            })
            .catch(error => {
                if (error instanceof Error) {
                    snackBar.showSnackBar(error.message, "error");
                }
            });
    };

    return (
        <ForgotPasswordPageWrapper>
            <div>
                {" "}
                <Logo src={YLLWLOGO} />
            </div>
            <div style={{ marginTop: "40px", textAlign: "center" }}>
                <Typography fontWeight={600} fontSize={24} sx={{ fontFamily: "Inter, sans-serif" }}>
                    Forgot your password?
                </Typography>
                <Typography
                    fontSize={16}
                    color="#8c8c8c"
                    fontWeight={600}
                    sx={{ fontFamily: "Inter, sans-serif", marginBottom: "12px" }}
                >
                    Let's recover it!
                </Typography>
            </div>
            <ForgotPasswordForm noValidate autoComplete="off">
                <TextField
                    label="E-mail"
                    variant="outlined"
                    onChange={e => {
                        setEmail(e.currentTarget.value);
                    }}
                />
                <ActionButtons>
                    <SoecoButton fullWidth color="primary" onClick={handleResetPassword}>
                        Send
                    </SoecoButton>
                    <SoecoButton fullWidth color="warning" onClick={() => navigate("/login")}>
                        Back
                    </SoecoButton>
                </ActionButtons>
            </ForgotPasswordForm>
        </ForgotPasswordPageWrapper>
    );
};
const Logo = styled.img`
    margin-bottom: 25%;
    margin-top: 85%;
    height: 50px;
    width: 300px;
`;
const ForgotPasswordPageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 80vh;
    justify-content: center;
    align-items: center;
    gap: 10px;
`;

const ForgotPasswordForm = styled.form`
    display: flex;
    flex-direction: column;
    width 80%;
    gap: 32px;
`;

const ActionButtons = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 16px;
`;
